import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import data from '../../data/contact';

const ContactIcons = () => (
  <ul className="icons">
    {data.map((s) => (
      <li key={s.label}>
        <a href={s.link} aria-label={`Visit Ajith Joseph on ${s.label}`}>
          <FontAwesomeIcon icon={s.icon} aria-hidden="true" />
        </a>
      </li>
    ))}
  </ul>
);

export default ContactIcons;
